import React from 'react';
import PropTypes from 'prop-types';

import FieldLabel from '../FieldLabel';
import Select from '../Select';
import styles from './styles.scss';
import withValidation from '../../shared/withValidation';

const defaultProps = {
  options: [],
};

class LabeledSelect extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getDisplayValue = this.getDisplayValue.bind(this);
  }

  getDisplayValue() {
    const { value, options } = this.props;

    const valueToCheck = typeof value === 'string' ? value : JSON.stringify(value);
    const displayValue = options.find((val) => {
      return val.value && value ? val.value.toUpperCase() === valueToCheck.toUpperCase() : false;
    });

    return displayValue ? displayValue.label : value;
  }

  render() {
    const { editMode, label, value, isnLabel, options, error } = this.props;

    return (
      <div>
        <FieldLabel isnLabel={isnLabel}>{label}</FieldLabel>
        <Choose>
          <When condition={editMode}>
            <Select {...this.props} value={value} options={options} />
          </When>
          <Otherwise>
            <label className={`d-block ${styles.label}`}>{this.getDisplayValue() || '-'}</label>
            {error && <label className={styles.error}>{error}</label>}
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

LabeledSelect.propTypes = {
  editMode: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  value: PropTypes.string,
  type: PropTypes.string,
  isnLabel: PropTypes.bool,
  options: PropTypes.array,
  allowBlank: PropTypes.bool,
  error: PropTypes.string,
};

LabeledSelect.defaultProps = defaultProps;
export default withValidation(LabeledSelect);



// WEBPACK FOOTER //
// src/components/shared/LabeledSelect/index.jsx